<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import { useInventoryStore } from '../pages/useInventoryStore/';
import { i18n } from '@/i18n';
import { contentPropertyOfMoveWarehouse, contentPropertyOfMoveWarehouseWithChoice } from '../constants/contentProperty';
import InfoModal from '@/corePagesModule/components/InfoModal.vue';
import NewBaseTableContent from '@/corePagesModule/BaseTableContent/NewBaseTableContent.vue';
import { InventoryRepository } from '@/coreInfrastructureModule/Repositories/InventoryRepository';
import { computed, ref } from 'vue';

const t = i18n.t;
const inventoryRepository = new InventoryRepository();
const store = useInventoryStore();
const { state } = storeToRefs(store);
const { applyMoveWarehouse } = store;

const checkIds = ref<string[]>([]);

/**
 * 置場移動登録ボタンをDisableにするかどうか
 * 変更のあった取引の差異数量と選択された取引の差異数量の和が0の場合にDisableにする
 */
const isDisableNextButton = computed(() => {
  const checkedIds = checkIds.value;
  const changedBusiness = state.value.moveWarehouseModalState.changedBusiness;
  const otherBusinesses = state.value.moveWarehouseModalState.otherBusinesses.filter((business) =>
    checkedIds.includes(business.businessId)
  );
  if (!changedBusiness || !otherBusinesses) return true;
  const changedAmount = changedBusiness.differenceAmount;
  const otherAmount = otherBusinesses.reduce((acc, business) => acc + business.differenceAmount, 0);
  return changedAmount + otherAmount !== 0;
});

/**
 * チェックボックスの選択時の処理
 * @param item - 選択されたアイテム
 */
const onChecked = (item: string[]) => {
  checkIds.value = item;
};
</script>
<template>
  <InfoModal
    :modal-state="state.moveWarehouseModalState.isOpen"
    :back-button-label="t('キャンセル')"
    :next-button-label="t('置場移動登録')"
    :is-disabled-next-button="isDisableNextButton"
    @on-back="state.moveWarehouseModalState.isOpen = false"
    @on-next="applyMoveWarehouse(inventoryRepository, checkIds)"
  >
    <template #title>{{ t('置場移動登録') }}</template>
    <div class="move-warehouse-modal__container">
      <div>
        <p class="move-warehouse-modal__title">{{ t('変更のあった取引') }}</p>
        <NewBaseTableContent
          class="move-warehouse-modal__table"
          :prop-table-content-properties="contentPropertyOfMoveWarehouse"
          :prop-display-objects="state.moveWarehouseModalState.changedBusiness ? [state.moveWarehouseModalState.changedBusiness] : []"
          :prop-loading-status="state.moveWarehouseModalState.loadingStatus"
          :prop-table-type="'moveWarehouse'"
        />
      </div>
      <div>
        <p class="move-warehouse-modal__text">{{ t('差異数量が合うように、置場移動した取引を選択して更新してください。') }}</p>
        <NewBaseTableContent
          class="move-warehouse-modal__table move-warehouse-modal__table--choice"
          :prop-table-content-properties="contentPropertyOfMoveWarehouseWithChoice"
          :prop-display-objects="state.moveWarehouseModalState.otherBusinesses"
          :prop-loading-status="state.moveWarehouseModalState.loadingStatus"
          :prop-table-type="'moveWarehouseWithChoice'"
          @checked="onChecked"
        />
      </div>
    </div>
  </InfoModal>
</template>
<style lang="scss" scoped>
.move-warehouse-modal {
  &__container {
    padding: 16px;
    background-color: $backgroundDefault;
    border-radius: 8px;
    display: grid;
    gap: 32px;
  }
  &__title {
    font-family: Noto Sans JP;
    font-size: 16px;
    font-weight: 700;
    line-height: 16px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: $textDefault;
    margin-bottom: 8px;
  }
  &__text {
    font-family: Noto Sans JP;
    font-size: 14px;
    font-weight: 400;
    line-height: 18.2px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: $textDefault;
    margin-bottom: 8px;
  }

  &__table {
    // max-height: 56px !important;
    min-height: 56px;

    &--choice {
      // max-height: 102px !important;
      min-height: 56px;
    }
  }
}
</style>
